/*
 * Checkbox selection component
 */

import React from 'react';

import {
  Mode,
  castDataType,
  DataType,
} from '../common.jsx';
import Setting from './setting.jsx';
import Selection from './selection.jsx';

import { ReadOnlyMultiSelectValues } from '../../common/Select.jsx';
import Tooltip from '../../common/Tooltip.jsx'

export default class CheckboxSelection extends Selection {

    // Don't confirm when adding new values, but only when option goes missing
    selectionCleared(currentValue, newValue) {
      // console.log(currentValue, newValue)
      if (currentValue == null) return false;
      if (newValue == null) return true;
      if (currentValue.length > newValue.length) return true;

      return false;
    }


        static get TYPE() {
            return 'checkbox_selection';
        }
        static icon(){
            return <i className="fa fa-check-square"></i>;
        }

        viewModeWholeScope() {
            return true;
        }

        renderPrettyView(){
            let options =  this.getOptions().filter(o => this.getAnswer().indexOf(o.value) != -1).map(o => {
                    return {label: this.getOptionText(o)};
                });
            const { hide = false, show_label = false } = this.props.content.prettyView || {};
            return ( hide ? null :
                <div>
                    {show_label &&
                        <label>
                            <span className="field-label">{this.getText('label')}</span>
                        </label>
                    }
                    {options.length > 0 ? <ReadOnlyMultiSelectValues values={options} /> : (<p><em>{I18n.t('no_selected_options', {scope: 'fe'})}</em></p>)}
                </div>
            );      
        }

        renderSettings() {
            return (
                <div>
                    {super.renderSettings()}
                    {<Setting.TextField name="limitMax" label={I18n.t('field_limit_max', {scope: 'fe'})} description={I18n.t('field_limit_max_description', {scope: 'fe'})} value={this.props.content.limitMax} onChange={this.updateSettings} />}
                </div>
            )
        }

        renderOptions() {
            const maxReached = this.props.content.limitMax && this.getAnswer().length >= this.props.content.limitMax;
            let options = this.getOptions().map((o, i) => {
                let isChecked = this.getAnswer().indexOf(o.value) != -1;
                let hiddenOption = null;

                if (isChecked && this.isReadOnlyAnswer()) {
                    hiddenOption = <input type="hidden" name={this.fullFieldName(true)} defaultValue={o.value} />
                }
                return (
                    <label className="box-text-align" key={i}>
                        {hiddenOption}
                        <input type="checkbox" key={o.value}
                            className={this.isReadOnlyAnswer() ? 'locked' : ''}
                            name={this.fullFieldName(true)}
                            defaultValue={o.value}
                            checked={isChecked}
                            onChange={(e) => this.handleChange(e.target.value)}
                            disabled={this.props.mode != Mode.FILL || this.isReadOnlyAnswer() || (!isChecked && maxReached) }/>
                        {this.renderOption(o)}
                    </label>
                );
            });

            if (maxReached) {
                return (
                    <div className="options">
                        <Tooltip title={I18n.t('checkbox_max_selections', {scope: 'fe', locale: this.props.language}).replace('%{amount}', this.props.content.limitMax)} >
                            {options.length > 0 ? options : (<p><em>{I18n.t('no_options', {scope: 'fe'})}</em></p>)}
                        </Tooltip>
                    </div>
                )
            } else {
                return (
                    <div className="options">
                        {options.length > 0 ? options : (<p><em>{I18n.t('no_options', {scope: 'fe'})}</em></p>)}
                    </div>
                )
            }

        }

        handleChange (value) {
          if (this.props.content.limitMax && value.length > this.props.content.limitMax) return; // Do nothing

          const selectedValue = castDataType(value, this.props.content.dataType || DataType.STRING);
          const selectedIndex = this.getAnswer().indexOf(selectedValue);
          let newValue = [...this.getAnswer()];

          if (selectedIndex == -1) {
            newValue.push(selectedValue);
          } else {
            newValue.splice(selectedIndex, 1);
          }

          this.updateAnswer(newValue);
        }

        getAnswer() {
            let answer = this.getRawAnswer();
            
            return (Array.isArray(answer) ? answer : [answer]).map((a) => {
                return castDataType(a, this.props.content.dataType || DataType.STRING);
            });
        }

        rawAnswerDefault() {
            return [];
        }
}
